import Share from "../../assets/icon/NewsIcons/MainAdmin/NewsShare"
import {MainAdminAddSocialNetworks} from "../../components"
import React, { useState, useEffect } from "react";
import Cookies from 'universal-cookie';
import { axiosReq } from "../../commons/axiosReq";
import { useNavigate } from "react-router-dom";

const MainAdminSocialNetworks = () => {

        const [showDeleteModal,setShowDeleteModal] = React.useState(false);
     const [reCheck, setRecheck] = useState(false);
        const [data, setData] = useState();
 
        const [count, setCount] = useState();
  
          let navigate = useNavigate();
    
   
           const GetData = async () => {
                const writersData = await axiosReq("Admins/GetSocial", "get");
                console.log(writersData)
                setData(writersData)
            }
            const auth = async () => {
                    const cookies = new Cookies();
                    var token = cookies.get('token');
                    console.log(token)
                    console.log(cookies.get('role'))
                    if (!token) {
                        navigate("/admin");
                    } else {
                        if( cookies.get('role')=="Admin" )
                       {
            
                           GetData()
                       }
            
                        
                        else {
                            navigate("/admin");
            
                        }
                    }
                }
            useEffect(() => {
        
                auth();
            }, [reCheck]);
    return(
        <div >
            <div className="flex items-center border-b-2 border-borderGray p-[20px]">
                <div className="flex items-center">
                    <div><Share color={'#184548'}/></div>
                    <p className="font-IRANYekanExtra text-[15px] text-mainColor2 mr-[15px]">شبکه های اجتماعی</p>
                </div>
            </div>
            {
                data?

            <div className="pt-[25px] pb-[200px] px-[20px]">
                <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminAddSocialNetworks  data={data[0]} /></div>
                <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminAddSocialNetworks  data={data[1]} /></div>
                <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminAddSocialNetworks  data={data[2]} /></div>
                <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminAddSocialNetworks  data={data[3]} /></div>
                <div className="pr-[30px] pl-[70px] py-[20px] border-b-[2px] border-borderGray"><MainAdminAddSocialNetworks  data={data[4]} /></div>
                <div className="pr-[30px] pl-[70px] py-[20px] "><MainAdminAddSocialNetworks  data={data[5]} /></div>
            </div>
                :
                null
            }
        </div>
    )
}

export default MainAdminSocialNetworks;